export enum CHECKOUT_STEP {
    INFORMATION = 'information',
    DELIVERY = 'delivery',
    CONFIRM = 'confirm-order',
}

export type DeliveryOptionsFormData = { postalCode?: string; streetName?: string };
